import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface FormSuccessProps {
  message: string;
  onClose?: () => void;
}

const FormSuccess = ({ message, onClose }: FormSuccessProps) => {
  const { t } = useTranslation();

  return (
    <motion.div
      className="fixed inset-0 flex items-center justify-center bg-black/50 z-50 px-4"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        className="bg-white rounded-xl p-8 max-w-md w-full text-center"
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
      >
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 rounded-full bg-[#EA295A]/10 flex items-center justify-center">
            <CheckCircle className="w-8 h-8 text-[#EA295A]" />
          </div>
        </div>
        <h3 className="text-xl font-bold text-gray-900 mb-2">{t('forms.success.title')}</h3>
        <p className="text-gray-600 mb-6">{message}</p>
        <motion.button
          onClick={onClose}
          className="bg-[#EA295A] text-white px-6 py-2 rounded-lg text-sm font-medium hover:bg-[#d01d4c] transition-all"
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          {t('forms.success.close')}
        </motion.button>
      </motion.div>
    </motion.div>
  );
};

export default FormSuccess;